import Api from '../../shared/Api';

export default class PhotographerCalendarApi {
    static getPhotographersByRegion() {
        return new Api().get('/views/photographer-calendars/by-region');
    }

    static getPhotographerCalendars(ids: number[], from: any, to: any) {
        let url =
            '/views/photographer-calendars?ids=' +
            ids.join('&ids=') +
            '&fromYear=' +
            from.year() +
            '&fromMonth=' +
            (from.month() + 1) +
            '&fromDay=' +
            from.date() +
            '&toYear=' +
            to.year() +
            '&toMonth=' +
            (to.month() + 1) +
            '&toDay=' +
            to.date();
        return new Api().get(url);
    }

    static getSpecificPhotographerCalendarItem(photographerId: number, calendarItem: number) {
        return new Api().get('/views/photographer-calendars/items/GetCalendarItem', {
            photographerId: photographerId,
            itemId: calendarItem
        });
    }

    static createPhotographerCalendarItem(item: any) {
        return new Api().post('/views/photographer-calendars/items', {
            photographerId: item.photographerId,
            item: item
        });
    }

    static deletePhotographerCalendarItem(item: any) {
        return new Api().delete('/views/photographer-calendars/items/' + item.id);
    }

    static updatePhotographerCalendarItem(item: any) {
        return new Api().put('/views/photographer-calendars/items/', {
            photographerId: item.photographerId,
            item: item
        });
    }

    static updatePhotographerCalendarWorkingHours(
        photographerId: number,
        se360WorkingHours: any[],
        scandphotosWorkingHours: any[]
    ) {
        return new Api().put('/views/photographer-calendars/working-hours', {
            photographerId: photographerId,
            se360WorkingHours: se360WorkingHours,
            scandphotosWorkingHours: scandphotosWorkingHours
        });
    }

    static createSmsToPhotographer(toPhoneNumber: string, body: string, desiredSendTime?: Date) {
        return new Api().post('/views/photographer-calendars/create-sms', {
            toPhoneNumber: toPhoneNumber,
            body: body,
            desiredSendTime: desiredSendTime
        });
    }

    static getSmsTemplates(photographerId: number) {
        return new Api().get('/views/photographer-calendars/get-sms-templates/' + photographerId);
    }

    static createEmailToPhotographer(
        fromEmail: string,
        toEmail: string,
        subject: string,
        body: string,
        cc?: string,
        desiredSendTime?: Date
    ) {
        return new Api().post('/views/photographer-calendars/email', {
            fromEmail,
            toEmail,
            cc,
            subject,
            body,
            desiredSendTime
        });
    }

    static getEmailTemplates(photographerId: number) {
        return new Api().get('/views/photographer-calendars/email-templates/' + photographerId);
    }

    static getEmailSenders() {
        return new Api().get('/views/photographer-calendars/email-senders/');
    }
}
